import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { CACHE_KEYS } from '../constants';
import { ApiResponse } from '@module/types';

type Request = {
  token: string;
};

type Response = ApiResponse<{
  id: string;
  firstName: string;
  organisationName: string;
  registrationStatus:
    | {
        registered: true;
      }
    | {
        registered: false;
        registrationType: string;

        // When the user is NOT registered, we may also receive preregistration
        // details that allow us to pre-fill forms and the API to automatically
        // approve the user
        preregistrationId?: string;
        registrationFormConfig?: {
          formLabels?: {
            [formField: string]: string;
          };
          lockedFields?: string[];
        };
        registrationFormValues?: {
          email: string;
          firstName: string;
          lastName: string;
          jobTitle: string;
          organisationId: number;
        };
      };
}>;

export const fetchPublicMe = (params?: Request, settings?: AxiosRequestConfig) => {
  return axios.request<Response>({
    method: 'GET',
    url: '/api/v3/public/users/me',
    params,
    ...settings,
  });
};

/**
 * Returns details about a user from the public /me endpoint
 */
export const useAuthCheckPublic = (params: Request, settings?: UseQueryOptions<Response['data'], AxiosError>) => {
  return useQuery([CACHE_KEYS.USER_PUBLIC, params], async () => (await fetchPublicMe(params)).data.data, settings);
};
